import { Analytics } from '@util/Analytics';
import React, { ReactElement } from 'react';
import { LayoutScreenConfig, ScreenType } from '../../config/FlowTypes';
import { ScreenWrapper } from '../styles/Containers';
import { NavigationProps } from './FlowNavigation';
import { LoadingResultsLayout, LoadingResultsLayoutConfig } from './layouts/LoadingResultsLayout';

export type LoadingResultsScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.LoadingResults,
  LoadingResultsLayoutConfig,
  ScreenNames
>;

type LoadingResultsScreenProps<ScreenNames extends string> = NavigationProps<
  LoadingResultsScreenConfig<ScreenNames>,
  ScreenNames
>;

export const LoadingResultsScreen = <ScreenNames extends string>(
  props: LoadingResultsScreenProps<ScreenNames>
): ReactElement => {
  function handleNext() {
    Analytics.track({
      event: Analytics.Event.o_questionnaire_completed,
      result: 'good-fit',
    });
    props.navigation.next(props, true);
  }

  return (
    <ScreenWrapper>
      <LoadingResultsLayout {...props.layout} onNext={handleNext} />
    </ScreenWrapper>
  );
};
